import React from 'react';

export function SortableListItemDragLayer({ name }: { name: string }) {
  return <span>{name}</span>;
}
